import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  roundedPromptsButton: {
    minWidth: "auto",
    ...shorthands.padding(designTokens.spacing[1]),
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral[600],
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.accent[500],
    },
  },
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
  },
  promptList: {
    position: "absolute",
    bottom: "100%",
    backgroundColor: designTokens.neutral.white,
    width: "250px",
    ...shorthands.padding(designTokens.spacing[2]),
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    boxShadow: designTokens.shadow.md,
    zIndex: 10,
    maxHeight: "200px",
    overflowY: "auto",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    rowGap: designTokens.spacing[2],
  },
  errorMessage: {
    color: designTokens.semantic.error,
    marginBottom: designTokens.spacing[2],
  },
});
